import useToggleHandler from "@/Hooks/useToggleHandler";
import { sideTabSchema } from "@/Routes/sidebar.utility";
import { useGetAuthUserService } from "@repo/api-services/admin";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import LogoutConfirmModal from "../LogoutConfirmModal/LogoutConfirmModal";
import LoggedInUserInfo from "./components/LoggedInUserInfo";
import SideTab from "./components/SideTab";
import SideBardLoader from "./components/SidebarLoader";

interface ISidebarProps {
  TABS: sideTabSchema[];
  logoutHandler: () => void;
}

function Sidebar({ TABS, logoutHandler }: ISidebarProps) {
  const { authService } = useGetAuthUserService();
  const { isOpen: isLogoutOpen, toggler } = useToggleHandler();
  const logoutModalHandler = () => {
    toggler();
  };
  const userPermission = authService?.data?.permissions;
  const allowedPermission = userPermission && Object.keys(userPermission);

  const updatePermission = allowedPermission?.map((item: string) => {
    return stringUtility.replaceCharAll(String(item), "_", "-");
  });

  const filteredTabs = TABS?.map((tab) => {
    if (tab.subTabs) {
      const allowedSubTabs = tab?.subTabs?.filter((sub) => {
        return updatePermission?.includes(sub?.code);
      });
      if (allowedSubTabs.length > 0) {
        return { ...tab, subTabs: allowedSubTabs };
      }
    } else if (updatePermission?.includes(tab?.code)) {
      return tab;
    }
    return null;
  })?.filter(Boolean);

  // This will hide the non-view access tabs to be selected

  const tabsToDisplay = userPermission?.[0] === "*" ? TABS : filteredTabs;
  return (
    <>
      <div className="max-[450px]:hidden">
        {" "}
        <div className="w-[15rem] flex flex-col justify-between fixed left-0 h-full py-4 !z-20 overflow-visible">
          {!authService?.isLoading ? (
            <div className="flex flex-col gap-4 px-2">
              <LoggedInUserInfo
                authUserService={authService}
                logoutModalHandler={logoutModalHandler}
              />
              <section
                id="hide-scrollbar"
                className={`flex flex-col px-1 h-[calc(100vh-140px)] gap-2 overflow-auto transition-all duration-500`}
              >
                {tabsToDisplay?.map((tabData) => {
                  return (
                    <SideTab
                      key={tabData?.name}
                      tabData={tabData}
                      expandSidebar={true}
                    />
                  );
                })}
              </section>

              <LogoutConfirmModal
                isOpen={isLogoutOpen}
                logoutHandler={logoutHandler}
                handleCloseModal={logoutModalHandler}
              />
            </div>
          ) : (
            <SideBardLoader />
          )}
        </div>
        <div className="w-[15rem] h-full" />
      </div>
    </>
  );
}

export default Sidebar;
